import React from 'react';
import { GetTypesTitles } from './Get/GetTypes';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import AUX from '../../hoc/AU-X/AU-X';
import { logout } from '../../store/index';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';

const GetData = () => {
  const dispatch = useDispatch();

  return (
    <AUX>
      <div className='homePage'>
        <NavLink className='goBack' to='/SelectFolder'>
          <Icon path={mdiArrowLeft} size={1} title='go back' />
        </NavLink>

        <div className='healthDays'>
          {GetTypesTitles.map((element) => (
            <NavLink key={element} to={`GetData/${element}`}>
              {element}
            </NavLink>
          ))}
        </div>
      </div>
      <div className='logout' onClick={() => dispatch(logout())}>
        logout
      </div>
    </AUX>
  );
};

export default GetData;
